import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { default as Slider } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router';
import moment = require('moment');
import { Tags } from 'components/Magazine/Article/Tag/Tags';

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

interface IState {
	sectionTitle: string;
	editedElements: Array<ISectionImageElement | ISectionTextElement>;
}

/* Component with 6 profiles positioned horizontaly */
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType6 extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);
		this.state = {
			sectionTitle: '',
			editedElements: [],
		};
	}

	componentDidMount(): void {
		if (this.props.section.data.elements.length) {
			const arr: Array<ISectionImageElement | ISectionTextElement> = [];
			this.props.section.data.elements.forEach((x) => {
				if (x.redirectUrl !== null) {
					arr.push(x);
				}
			});
			this.setState({ editedElements: arr });
		}
		const sectionTitle = (
			this.props.section.data.elements[this.props.section.data.elements.length - 1] as ISectionTextElement
		).text;
		if (sectionTitle) {
			this.setState({ sectionTitle });
		}
	}

	private renderSlides() {
		const { editedElements } = this.state;
		const elementsToReturn: JSX.Element[] = [];

		if (editedElements.length) {
			editedElements.map((x, index) => {
				if (typeof (x as ISectionImageElement).imageUrl === 'string' && index !== editedElements.length - 1) {
					const tags = (editedElements[index + 1] as ISectionTextElement).tags;
					elementsToReturn.push(
						<div className="slide" key={index}>
							<Link
								className="slideImage"
								to={(x as ISectionImageElement).redirectUrl}
								style={{
									backgroundImage: `url(${(x as ISectionImageElement).imageUrl})`,
								}}
							>
								<div className="titleContainer">
									<p className="title">{`${(editedElements[index + 1] as ISectionTextElement).title}`}</p>
								</div>
							</Link>
							<div className="bottomText">
								<Tags tags={tags} displayNumber={2} onClick={true} />
								<div className="info">
									<p className="p12 text author">{(editedElements[index + 1] as ISectionTextElement).text}</p>
									<span>&#8226;</span>
									<p className="p12 text gray date">
										{moment((editedElements[index + 1] as ISectionTextElement).date).format('L')}
									</p>
								</div>
							</div>
						</div>,
					);
				}
			});
		}
		return elementsToReturn;
	}

	public render() {
		const settings = {
			dots: false,
			infinite: true,
			speed: 674,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			swipe: false,
			easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
			responsive: [
				{
					breakpoint: 992,
					settings: {
						dots: false,
						infinite: true,
						speed: 674,
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						arrows: true,
						swipe: true,
						easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
					},
				},
				{
					breakpoint: 660,
					settings: {
						dots: false,
						infinite: true,
						speed: 674,
						slidesToShow: 2,
						rows: 1,
						centerMode: true,
						slidesToScroll: 1,
						arrows: true,
						swipe: true,
						easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
					},
				},
				{
					breakpoint: 490,
					settings: {
						dots: false,
						infinite: true,
						speed: 674,
						slidesToShow: 1,
						rows: 1,
						centerMode: true,
						slidesToScroll: 1,
						arrows: true,
						swipe: true,
						easing: 'cubic-bezier(0.4, 0.0, 0.25, 0.9)',
					},
				},
			],
		};

		return (
			<div className="container sectionType6container">
				<h1 className="sectionTitle">{this.state.sectionTitle}</h1>
				<div className="row">
					<div className="col-md-12 no_pad">
						<div className="sliderHolder">
							<Slider {...settings}>{this.renderSlides()}</Slider>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType6 };
